import React, { useCallback, useEffect, useRef, useState } from "react";
import Login from "./components/Login";

import { useTimer } from "react-use-precision-timer";

import { useAuthContext } from "./context/auth";
import PortraitDefault from "./components/PortraitDefault";
import Admin from "./components/Admin/Admin";
import Loading from "./components/Loading";
import LoadingPortrait from "./components/LoadingPortrait";
import ControlPanel from "./components/ControlPanel";
import PortraitScreen from "./PortraitScreen";
import useClub from "./hooks/useClub";
import { Toaster } from "react-hot-toast";

function App() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    isAuthenticated,
    loading,
    did,
    step,
    circuitProgram,
    basicProgram,
    setStep,
  } = useAuthContext();
  const clubDayBadges = useClub();

  const resizeContent = useCallback(() => {
    if (!ref.current) return;

    const scale = Math.min(1, window.innerWidth / 1920);
    const containerHeight = window.innerHeight;
    const scaledHeight = 1080 * scale;

    // 위아래 중앙 정렬을 위한 Y축 위치 계산
    const yOffset = Math.max(0, (containerHeight - scaledHeight) / 2);

    // transform으로 스케일 및 세로 위치 조정
    ref.current.style.transform = `scale(${scale}) translateY(${
      yOffset / scale
    }px)`;
    ref.current.style.transformOrigin = "top left";
  }, []);

  useEffect(() => {
    if (did === "0") {
      // 마운트 시 바로 실행
      setTimeout(() => {
        resizeContent();
      }, 100);

      // 이벤트 리스너 등록
      window.addEventListener("resize", resizeContent);

      // 언마운트 시 정리(cleanup) - 메모리 누수 방지
      return () => {
        window.addEventListener("resize", resizeContent);
      };
    }
  }, [resizeContent, did]); // 의존성 배열에 resizeContent 포함

  if (loading) {
    return did === "1" || did === "0" ? (
      <div className="content-wrapper" ref={ref}>
        <Loading key={"loading"} />
      </div>
    ) : (
      <div className="content-wrapper" ref={ref}>
        <LoadingPortrait key={"loading-portrait"} />
      </div>
    );
  }
  if (!isAuthenticated)
    return (
      <div className="content-wrapper" ref={ref}>
        <Login />
      </div>
    );

  const getScreen = () => {
    const clubDayChunks = [];
    for (let i = 0; i < clubDayBadges.length; i += 4) {
      clubDayChunks.push(clubDayBadges.slice(i, i + 4));
    }

    if (did === "0" && step === 0) {
      return <Admin key={"admin"} />;
    }

    if (did === "0" && step > 0) {
      return (
        <ControlPanel key={"control-panel"} clubDayChunks={clubDayChunks} />
      );
    }

    return (
      <PortraitScreen key={"portrait-screen"} clubDayChunks={clubDayChunks} />
    );
  };
  return (
    <div className="content-wrapper" ref={ref}>
      {getScreen()}
      <Toaster />
    </div>
  );
}

export default App;
